<template>
  <div id="main">
    <NavBar />

    <div id="hero" class="hero">
      <div class="hero-content">
        <div class="hero-text"></div>
        <!-- /.hero-text -->
      </div>
      <!-- /.hero-content -->
    </div>
    <!-- /.hero -->

    <section class="site-section section-portfolio">
      <div class="container">
        <div class="text-center">
          <h2 class="heading-separator">产品特辑</h2>
          <p class="subheading-text">以下產品乃屬本公司所擁有</p>
        </div>
        <div class="row">
          <div
            class="col-lg-3 col-md-4 col-xs-6 mb-4"
            v-for="(productItem, productIndex) in productList"
            :key="productIndex"
          >
            <div class="portfolio-item">
              <img
                :src="require('@/assets/img/products/' + productItem.img)"
                class="img-res mx-auto"
                alt=""
              />
              <h4 class="portfolio-item-title">{{ productItem.title }}</h4>
              <router-link class="text-black" :to="productItem.link">
                <i class="fa fa-arrow-right" aria-hidden="true"></i>
              </router-link>
            </div>
            <router-link class="text-center" :to="productItem.link">
              <h3 class="mt-2">{{ productItem.title }}</h3>
            </router-link>
            <!-- /.portfolio-item -->
          </div>
        </div>
        <div class="row text-center mt-50">
          <div class="col-sm-12 ">
            <router-link class="btn btn-green" to="/products"
              >更多产品</router-link
            >
          </div>
        </div>
      </div>
    </section>
    <!-- /.section-portfolio -->

    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from "./partials/NavBar.vue";
import Footer from "./partials/Footer.vue";

export default {
  name: "MainIndex",
  data() {
    return {
      productList: [
        {
          img: "huan-zai-jin.jpg",
          title: "還債金",
          link: "/products/huan-zai-jin"
        },
        {
          img: "tai-sui-dian.jpg",
          title: "太歲殿",
          link: "/products/tai-sui-dian"
        },
        {
          img: "di-zhu-jin.jpg",
          title: "地主金",
          link: "/products/di-zhu-jin"
        },
        {
          img: "nan-dou-liu-xing-yan-shou-deng.jpg",
          title: "南斗六星延壽燈",
          link: "/products/nan-dou-liu-xing-yan-shou-deng"
        },
        {
          img: "tai-sui-jin.jpg",
          title: "太歲金",
          link: "/products/tai-sui-jin"
        },
        {
          img: "tian-guan-jin.jpg",
          title: "天官金",
          link: "/products/tian-guan-jin"
        },
        {
          img: "wan-fo-shen-qi-ye.jpg",
          title: "萬佛神奇液",
          link: "/products/wan-fo-shen-qi-ye"
        },
        {
          img: "wan-fo-shen-xiang-you.jpg",
          title: "萬佛神香油",
          link: "/products/wan-fo-shen-xiang-you"
        },
        {
          img: "wen-wu-cai-shen-bao-ku.jpg",
          title: "文武財神寶庫",
          link: "/products/wen-wu-cai-shen-bao-ku"
        },
        {
          img: "shou-sheng-qian.jpg",
          title: "壽生錢",
          link: "/products/shou-sheng-qian"
        },
        {
          img: "wen-chang-jin.jpg",
          title: "文昌金",
          link: "/products/wen-chang-jin"
        },
        {
          img: "zhu-ge-kong-ming-chen-tan-xiang.jpg",
          title: "諸葛孔明沉檀香",
          link: "/products/zhu-ge-kong-ming-chen-tan-xiang"
        },
        {
          img: "3-he-1-da-zhuan-yun-fa.jpg",
          title: "3合1",
          link: "/products/3-he-1-da-zhuan-yun-fa"
        }
      ]
    };
  },
  components: {
    NavBar,
    Footer
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/components/Main.vue